import { motion } from 'framer-motion';
import { useCallback, useState } from 'react';

import { useLanguage } from '../LanguageContext';

function renderAnswer(text) {
  const parts = text.split(/(<copy>.*?<\/copy>)/g);
  return parts.map((part, i) => {
    const match = part.match(/^<copy>(.*?)<\/copy>$/);
    if (match) {
      return <CopySpan key={i} text={match[1]} />;
    }
    return part;
  });
}

function CopySpan({ text }) {
  const [copied, setCopied] = useState(false);

  const handleClick = useCallback(() => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }, [text]);

  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <span
        onClick={handleClick}
        style={{
          cursor: 'pointer',
          fontWeight: 600,
          textDecoration: 'underline dotted',
          userSelect: 'none',
        }}
        title={`Click to copy ${text}`}
      >
        {text}
      </span>
      {copied && (
        <span
          style={{
            position: 'absolute',
            bottom: '120%',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0,0,0,0.75)',
            color: '#fff',
            fontSize: '0.7rem',
            padding: '2px 6px',
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
          }}
        >
          Copied!
        </span>
      )}
    </span>
  );
}

export default function QaPage() {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useLanguage();

  const faqs = [
    {
      question: t('qa.q1'),
      answer: t('qa.a1'),
    },
    {
      question: t('qa.q2'),
      answer: t('qa.a2'),
    },
    {
      question: t('qa.q3'),
      answer: t('qa.a3'),
    },
    {
      question: t('qa.q4'),
      answer: t('qa.a4'),
    },
    {
      question: t('qa.q5'),
      answer: t('qa.a5'),
    },
    {
      question: t('qa.q6'),
      answer: t('qa.a6'),
    },
  ];

  return (
    <div className="w-full min-h-screen mx-auto">
      {/* FAQ Items */}
      <div className="space-y-4">
        {faqs.map((faq, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.1 }}
            className="pb-4 border-b border-wedding-divider last:border-b-0"
          >
            <h3 className="text-lg text-content-h2 mb-2 text-left">
              <i>{faq.question}</i>
            </h3>
            <p className="text-lg text-content-c2 whitespace-pre-line text-left">
              {renderAnswer(faq.answer)}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
